import React, { useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import { Downgraded, useState } from '@hookstate/core';

const listStyle = {
    width: '100%',
    height: '200px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '5px',
        height: '5px',
        backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
    }
}
const UserCheckList = (props) => {
    const selected = useState([]);
    const handleToggle = (value) => {
        const newSelected = selected.attach(Downgraded).get();
        const currentIndex = newSelected.indexOf(value.actualData.userID);
        if (currentIndex === -1) {
            newSelected.push(value.actualData.userID);
        } else {
            newSelected.splice(currentIndex, 1);
        }

        if (newSelected) {
            props.checkUsers(newSelected);
        }
        selected.set(newSelected);
    };

    useEffect(() => {
        if (props.selectedUsers) {
            selected.set(props.selectedUsers)
        }
    }, [props])
    return (
        <List sx={listStyle}>
            {props.data &&
                props.data.map((item, index) => {
                    const labelId = `checkbox-list-label-${index}`;
                    return (
                        <ListItem key={`user_${index}`} disablePadding>
                            <ListItemButton
                                role={undefined}
                                onClick={() => handleToggle(item)}
                                dense>
                                {props.sentInvitationList != undefined ? null :
                                    <ListItemIcon sx={{ height: '28px' }}>
                                        <Checkbox
                                            edge="start"
                                            checked={
                                                selected.get().indexOf(item.actualData.userID) !== -1
                                            }
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{
                                                'aria-labelledby': labelId,
                                            }}
                                        />
                                    </ListItemIcon>
                                }
                                <ListItemText sx={{ textAlign: 'left', flex: '0.3' }}

                                    primary={item?.actualData.participant?.toLowerCase()}
                                />
                                {props.showRole && <ListItemText sx={{ textAlign: 'left', flex: '0.3' }}

                                    primary={item.roleName}
                                />}
                                {props.showRole && <ListItemText sx={{ textAlign: 'left', flex: '0.3' }}
                                >
                                    {item.userTags !== null && item.userTags.split(', ').map((tag, i) => {
                                        return <Chip key={i} sx={{ mr: '4px', mb: '2px' }} label={tag} />
                                    })}
                                </ListItemText>}
                            </ListItemButton>
                        </ListItem>
                    );
                })}
        </List>
    );
};

export default UserCheckList;
